import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { FlexColumn } from 'ui-components/components/flex';
import { EmptyRowAddItemsButton } from './add-items-button';
import EmptyItemsSVG from '../../empty-items.svg';
import { emptyRowMessage } from './messages';

import style from './shipment-items-table-empty-row.module.less';

const ShipmentItemsTableEmptyRow = ({ isReturn = false }) => {
  return (
    <FlexColumn className={style.container}>
      <img alt='' className={style.image} src={EmptyItemsSVG} />
      <div className={style.message}>
        <FormattedMessage {...emptyRowMessage} values={{ isReturn }} />
      </div>
      <div>
        <EmptyRowAddItemsButton />
      </div>
    </FlexColumn>
  );
};

export { ShipmentItemsTableEmptyRow };

ShipmentItemsTableEmptyRow.propTypes = {
  isReturn: PropTypes.bool,
};
